export default __webpack_public_path__ + "static/media/certlayout_blank.8035adea.png";